import { Button, Stack, Typography } from "@mui/material";
import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { auth } from "../../firebase";

export default function Login() {
  const onClick = async () => {
    const p = new GoogleAuthProvider();
    await signInWithPopup(auth, p);
    const next = new URLSearchParams(window.location.search).get("next") || "/";
    window.location.replace(next);
  };

  return (
    <Stack alignItems="center" mt={8} gap={2}>
      <Button variant="contained" onClick={onClick}>
        Sign in with Google
      </Button>
    </Stack>
  );
}
